<template>
	<div class="tab-pane-snapshot-wrapper">
		<!-- блок с локальным сообщением об ошибке -->
		<transition name="fadeControl" key="transitionError">
			<div v-show="localErrorMessage !== ''" class="alert alert-danger margin-20-0" role="alert">
				<button @click="localErrorMessage = ''" class="close" :title="'main/close' | ftc">×</button>
				<span style="padding:0;margin:0;" v-withSafeTags="localeFtc(localErrorMessage)"></span>
			</div>
		</transition>

		<!-- доп.информация -->
		<div class="w5-form-additional-info" style="margin-right: 0; margin-top: 15px">
			<template v-if="vdsBackupData && typeof vdsBackupData === 'object' && Object.keys(vdsBackupData).length && !Array.isArray(vdsBackupData)">
				<span v-if="'max' in vdsBackupData" class="pull-left">{{ 'main/available_to_order' | ftc }}: <strong>{{ vdsBackupData.max }}</strong></span>
				<span v-if="'cost' in vdsBackupData" class="pull-right" v-withSafeTags="localeFtc(costInfo)"></span>
				<span class="clearfix"></span>
			</template>

			<!-- кнопка создания -->
			<div class="w5-form-row btn-wrapper" :class="{ 'with-table': cacheData && cacheData.length }">
				<div v-if="backupScheduleHas === true && isAccess('backupschedule/update')" class="btn btn-submit font-weight-300 top-btn" @click="updateBackupSchedule" :disabled="!Access || Error ? 'disabled' : false">{{ 'schedule/update_title' | ftc }}</div>
				<div v-else-if="backupScheduleHas === false && isAccess('backupschedule/create')" class="btn btn-submit font-weight-300 top-btn" @click="createBackupSchedule" :disabled="!Access || !vdsBackupData ? 'disabled' : false">{{ 'schedule/create_title' | ftc }}</div>
				<div v-else class="btn btn-submit font-weight-300 top-btn" :disabled="backupScheduleHas === null ? 'disabled' : false">{{ backupScheduleMode === 'create' ? 'schedule/create_title' : 'schedule/update_title' | ftc }}</div>

				<div class="btn btn-submit font-weight-300 top-btn" @click="createBackup" :disabled="!Access || !vdsBackupData ? 'disabled' : false">{{ 'service/backup_create' | ftc }}</div>
			</div>
		</div>
		<br>
		

		<!-- таблица -->
		<table class="w5-snapshot-table margin-top-5">
			<thead>
				<tr>
					<th class="w5-snapshot-table-th--1">
						<span v-if="cacheData">{{ 'template/os' | ftc }}</span>
					</th>
					<th class="w5-snapshot-table-th-0">
						<span v-if="cacheData">{{ 'service/backup' | ftc }}</span>
					</th>
					<th class="w5-snapshot-table-th-2">
						<span v-if="cacheData">{{ 'main/status' | ftc }}</span>
					</th>
					<th class="w5-snapshot-table-th-1">
						<span v-if="cacheData">{{ 'main/created' | ftc }}</span>
					</th>
					<!-- колонка операций над строкой -->
					<th class="w5-column-opers" style="width: 45px">&nbsp;</th>
				</tr>
			</thead>
			<tbody>
				<template v-if="cacheData && cacheData.length">
					<tr v-for="(row, rowIdx) in cacheData" :key="rowIdx">
						<td :aria-label="'template/os' | ftc">
							<span class="w5-table-cell text-center">
								<img v-if="row && row['image']" :src="APIServerUrl + row['image']" class="backups-small" />
								<font-awesome-icon v-else icon="hdd" />
							</span>
						</td>
						<td :aria-label="'service/service' | ftc">
							<span class="w5-table-cell" :style="!(Access && !row['Status']['loader'] && !row['Status']['timer'] && isInField(row['id'])) ? 'opacity: 0.5' : null">
								<span v-if="row['datacenter_country']" class="flag-icon" :class="'flag-icon-' + String(row['datacenter_country']).toLowerCase()" style="margin-right: 10px; top: -1px;"></span>{{ row['full_name'] | ftc }}
							</span>
						</td>
						<td :aria-label="'main/status' | ftc">
							<span class="w5-table-cell">
								<span v-if="row['Status']['loader']" class="margin-right-10" :class="'w5-status-color-' + row['status']" style="white-space: normal">{{ row['Status']['status'] | lower }} <img src="../../assets/img/loading-hor16.gif" style="margin-left: 6px" /></span>
								<span v-else-if="row['Status']['timer']" class="margin-right-10" :class="'w5-status-color-' + row['status']" style="white-space: normal">{{ row['Status']['status'] | lower }} <font-awesome-icon icon="clock" style="margin-left: 6px" /></span>
								<span v-else class="margin-right-10" :class="'w5-status-color-' + row['status']" style="white-space: normal">{{ row['Status']['status'] | lower }}</span>
							</span>
						</td>
						<td :aria-label="'main/created' | ftc" style="text-align: center">
							<span class="w5-table-cell">
								{{ formater_StrDateFormat(row['created']) }}
							</span>
						</td>
						<td>
							<!-- для мобил -->
							<div v-if="$store.state.windowWidth <= 767" class="w5-opers-button-for-mobile">
								<!-- кнопка восстановления -->
								<div v-if="Access && !row['Status']['loader'] && !row['Status']['timer'] && isInField(row['id'])"
									@click.stop="restoreBackup(row['id'])"
									class="w5-opers-button-curd-btn"
									:title="localeFtc('main/restore server/server')">
									<font-awesome-icon icon="hdd" style="font-size: 16px" />
								</div>
								<!-- кнопка создать сервер из бэкапа -->
								<div v-if="Access && !row['Status']['loader'] && !row['Status']['timer'] && isInField(row['id'])"
									@click.stop="createFromBackup(row)"
									class="w5-opers-button-curd-btn"
									:title="localeFtc('main/create server/server')">
									<font-awesome-icon icon="plus" style="font-size: 16px" />
								</div>
								<!-- кнопка переименования бэкапа 
								<div v-if="Access && !row['Status']['loader'] && !row['Status']['timer'] && isInField(row['id'])"
									@click.stop="renameBackup(row)"
									class="w5-opers-button-curd-btn"
									:title="localeFtc('service/rename_action')">
									<font-awesome-icon icon="pencil-alt" style="font-size: 16px" />
								</div>
								-->
								<!-- кнопка генерации ссылки на скачивание бэкапа 
								<div v-if="Access && !row['Status']['loader'] && !row['Status']['timer'] && isInField(row['id'])"
									@click.stop="downloadBackup(row)"
									class="w5-opers-button-curd-btn"
									:title="localeFtc('backup/download_title')">
									<font-awesome-icon icon="cloud-download-alt" style="font-size: 16px" />
								</div>
								-->
								<!-- кнопка удаления -->
								<div v-if="Access && !row['Status']['loader'] && !row['Status']['timer']"
									@click.stop="deleteBackup(row['id'])"
									class="w5-opers-button-curd-btn"
									:title="localeFtc('main/delete')">
									<font-awesome-icon icon="trash-alt" class="color-red" style="font-size: 16px" />
								</div>
							</div>
							<!-- для десктопов -->
							<div v-else-if="$store.state.windowWidth > 767 && thereAreItems(row)"
								:class="{ 'w5-opers-button-opened': row['__btnShow'] }"
								class="btn-group w5-opers-button"
								:data-id="row['id']"
								@click.stop="toggleMenu(row)">
								<!-- сама кнопка -->
								<span class="dropdown-toggle">
									<font-awesome-icon icon="bars" /> <span class="caret"></span>
								</span>
								<!-- пункты меню -->
								<ul v-show="row['__btnShow']" class="dropdown-menu" role="menu" @click.stop :style="cssUl">

									<!-- кнопка восстановления -->
									<li v-if="Access && !row['Status']['loader'] && !row['Status']['timer'] && isInField(row['id'])"
										@click.stop="restoreBackup(row['id'])">
										<font-awesome-layers class="w5-dropdown-menu-item w5-opers-button-other-btn">
											<font-awesome-icon icon="hdd" />
											{{ 'main/restore server/server' | ftc | capitalize }}
										</font-awesome-layers>
									</li>

									<!-- кнопка создать сервер из бэкапа -->
									<li v-if="Access && !row['Status']['loader'] && !row['Status']['timer'] && isInField(row['id'])"
										@click.stop="createFromBackup(row)">
										<font-awesome-layers class="w5-dropdown-menu-item w5-opers-button-other-btn">
											<font-awesome-icon icon="plus" />
											{{ 'main/create server/server' | ftc | capitalize }}
										</font-awesome-layers>
									</li>

									<!-- кнопка переименования бэкапа
									<li v-if="Access && !row['Status']['loader'] && !row['Status']['timer'] && isInField(row['id'])"
										@click.stop="renameBackup(row)">
										<font-awesome-layers class="w5-dropdown-menu-item w5-opers-button-other-btn">
											<font-awesome-icon icon="pencil-alt" />
											{{ 'service/rename_action' | ftc | capitalize }}
										</font-awesome-layers>
									</li>
									-->

									<!-- кнопка генерации ссылки на скачивание бэкапа
									<li v-if="Access && !row['Status']['loader'] && !row['Status']['timer'] && isInField(row['id'])"
										@click.stop="downloadBackup(row)">
										<font-awesome-layers class="w5-dropdown-menu-item w5-opers-button-other-btn">
											<font-awesome-icon icon="cloud-download-alt" />
											{{ 'backup/download_title' | ftc | capitalize }}
										</font-awesome-layers>
									</li>
									-->

									<li v-if="Access && !row['Status']['loader'] && !row['Status']['timer'] && isInField(row['id'])" class="divider"></li>

									<!-- кнопка удаления -->
									<li v-if="Access && !row['Status']['loader'] && !row['Status']['timer']"
										@click.stop="deleteBackup(row['id'])">
										<span class="w5-dropdown-menu-item w5-opers-button-other-btn">
											<font-awesome-icon icon="trash-alt" class="color-red" />
											{{ 'main/delete' | ftc }}
										</span>
									</li>
								</ul>
							</div>
						</td>
					</tr>
				</template>
				<tr v-else>
					<td colspan="4" class="text-center">
						<img src="../../assets/img/puzzle.png" class="w5-empty-table-img" />
						<br>
						<span class="font-size-110 w5-empty-table-hint">{{ 'main/empty_table' | ftc }}</span>
					</td>
				</tr>				
			</tbody>
		</table>

		<!-- диалог создания -->
		<transition name="modal">
			<div v-show="showCreateModal" @click="hideCreateModal" class="modal-mask">
				<div class="modal-wrapper">
					<div class="modal-container" @click.stop>

						<!-- заголовок -->
						<div class="modal-header">
							<span class="font-weight-500">{{ 'service/creating_backup' | ftc }}</span>
							<button type="button" class="close" @click="hideCreateModal">&times;</button>
						</div>

						<!-- тело диалога -->
						<div class="modal-body">
							<p class="padding-0-5" v-withSafeTags="localeFtc(createModalText)"></p>
						</div>

						<!-- подвал -->
						<div class="modal-footer">
							<span class="btn btn-submit pull-right" @click="createBackupBegin">{{ 'service/backup_create' | ftc }}</span>
						</div>
					</div>
				</div>
			</div>
		</transition>



		<!-- диалог удаления -->
		<transition name="modal">
			<div v-show="showDeleteModal" @click="hideDeleteModal" class="modal-mask">
				<div class="modal-wrapper">
					<div class="modal-container" @click.stop>

						<!-- заголовок -->
						<div class="modal-header">
							<span class="font-weight-500">{{ deleteID === 'schedule' ? 'schedule/deleting' : 'service/deleting_backup' | ftc }}</span>
							<button type="button" class="close" @click="hideDeleteModal">&times;</button>
						</div>

						<!-- тело диалога -->
						<div class="modal-body">
							<p class="padding-0-5" v-withSafeTags="localeFtc(deleteModalText)"></p>
						</div>

						<!-- подвал -->
						<div class="modal-footer">
							<span class="btn btn-submit btn-submit-danger pull-right" :disabled="deleteModalTimer && deleteModalTimer > 0 ? 'disabled' : false" @click="deleteBackupBegin">{{ modalDeleteButtonTitle }}</span>
						</div>
					</div>
				</div>
			</div>
		</transition>



		<!-- диалог восстановления -->
		<transition name="modal">
			<div v-show="showRestoreModal" @click="hideRestoreModal" class="modal-mask">
				<div class="modal-wrapper">
					<div class="modal-container" @click.stop>

						<!-- заголовок -->
						<div class="modal-header">
							<span class="font-weight-500">{{ 'service/restore' | ftc }}</span>
							<button type="button" class="close" @click="hideRestoreModal">&times;</button>
						</div>

						<!-- тело диалога -->
						<div class="modal-body">
							<p class="padding-0-5" v-withSafeTags="localeFtc(restoreBodyTextModal)"></p>
						</div>

						<!-- подвал -->
						<div class="modal-footer">
							<span class="btn btn-submit btn-submit-danger pull-right" @click="restoreBackupBegin">{{ 'service/restore' | ftc }}</span>
						</div>
					</div>
				</div>
			</div>
		</transition>


		<!-- диалог переименования бэкапа -->
		<transition name="modal">
			<div v-show="showRenameBackupDialog" @click="hideRenameBackupDialog" class="modal-mask">
				<div class="modal-wrapper">
					<div class="modal-container" @click.stop>

						<!-- заголовок -->
						<div class="modal-header">
							<span class="font-weight-500">{{ 'main/name' | ftc }}</span>
							<button type="button" class="close" @click="hideRenameBackupDialog">&times;</button>
						</div>

						<!-- тело диалога -->
						<div class="modal-body" style="padding: 10px 15px; text-align: left;">
							<!-- форма -->
							<form class="w5-from"><fieldset>
								<!-- заметка -->
								<div class="w5-form-row">
									<Field
										:isVisibleRow="true"
										crud="backup"
										action="list"
										v-model="renameBackupValue"
										:Field="renameBackupField"
										:removeRightPadding="true"
										:fieldInModal="true"
										@enterKeyDown="renameBackupKeyDown"
										@focus="renameBackupField._errMsg = ''" />
								</div>
							</fieldset></form>
						</div>

						<!-- подвал -->
						<div class="modal-footer">
							<span class="btn btn-submit btn-submit-danger pull-right" @click="renameBackupStart">{{ 'service/rename_action' | ftc }}</span>
						</div>
					</div>
				</div>
			</div>
		</transition>



		<!-- диалог генерации ссылки для скачивания бэкапа -->
		<transition name="modal">
			<div v-show="showDownloadBackupModal" @click="hideDownloadBackupModal" class="modal-mask">
				<div class="modal-wrapper">
					<div class="modal-container" @click.stop>

						<!-- заголовок -->
						<div class="modal-header">
							<span class="font-weight-500">{{ 'backup/download_title' | ftc }}</span>
							<button type="button" class="close" @click="hideDownloadBackupModal">&times;</button>
						</div>

						<!-- тело диалога -->
						<div class="modal-body">
							<p class="padding-0-5" v-withSafeTags="localeFtc('backup/download_info')"></p>
						</div>

						<!-- подвал -->
						<div class="modal-footer">
							<span class="btn btn-submit pull-right" @click="downloadBackupProcessStart">{{ 'main/download' | ftc }}</span>
						</div>
					</div>
				</div>
			</div>
		</transition>



		<!-- диалог создания/редактирования расписания -->
		<transition name="modal">
			<div v-show="showBackupScheduleModal" @click="hideBackupScheduleModal" class="modal-mask">
				<div class="modal-wrapper">
					<div class="modal-container modal-form" @click.stop>

						<!-- заголовок -->
						<div class="modal-header">
							<span class="font-weight-500">{{ backupScheduleMode === 'create' ? 'schedule/create_title' : 'schedule/update_title' | ftc }}</span>
							<button type="button" class="close" @click="hideBackupScheduleModal">&times;</button>
						</div>

						<!-- тело диалога -->
						<div v-if="backupScheduleForm && backupScheduleForm.fields" class="modal-body">
							<!-- форма редактирования -->
							<form class="w5-from">
							<fieldset :disabled="form_Loading">

								<!-- поля -->
								<div v-for="(row, index) in backupScheduleForm.fields" :key="index" :class="{ 'w5-form-row': isVisibleField(row) }">
									<template v-if="row">
										<Field v-for="field in row"
											:key="field._field_name"
											:isVisibleRow="isVisibleField(row)"
											:fieldInModal="true"
											:action="backupScheduleMode"
											:Field="field"
											:listBlockToOut="1"
											crud="backupschedule"
											v-model="field.value"
											@valueChanged="fieldChanged(field)" />
									</template>
								</div>

							</fieldset>
							</form>
						</div>

						<!-- подвал -->
						<div class="modal-footer">
							<span class="btn btn-submit pull-right" :disabled="createScheduleEmpty" @click="createBackupScheduleBegin">{{ backupScheduleMode === 'create' ? 'schedule/create_title' : 'schedule/update_title' | ftc }}</span>
						</div>
					</div>
				</div>
			</div>
		</transition>



	</div>
</template>

<script>
///////////////////////////////////////////////////////////////////////////////
import Vue from 'vue'
import $ from 'jquery'
import Helper from '@/helper/helper'
import { EventBus } from '@/bus.js'
import Field from '@/components/elements/formfield'
///////////////////////////////////////////////////////////////////////////////
export default {
	//=========================================================================
	// наименование
	//=========================================================================
	name: 'tabBackup',
	//=========================================================================
	// данные переденные родителем
	//=========================================================================
	props: [
		'active',
		'vdsId',
		'vdsName',
		'vdsInfo',
		'account',
		'backup',
		'backupList',
		'access',
		'planInfo',
		'serviceStatus',
		'parentError',
		'dc'
	],
	//=========================================================================
	// вычисляемые свойства
	//=========================================================================
	computed: {
		// кнопка на модальном диалоге удаления
		modalDeleteButtonTitle() {
			if (!this.deleteModalTimer || this.deleteModalTimer <= 0) return this.localeFtc('main/delete')
			return this.localeFtc('main/delete_timer').replace('{count}', this.deleteModalTimer)
		},
		// информация о стоимости
		costInfo() {
			if (!this.vdsBackupData || !this.planInfo ||
				!('cost' in this.vdsBackupData) ||
				!('period' in this.vdsBackupData) ||
				!('disk' in this.planInfo))
				return ''

			let _wholeCost = this.vdsBackupData['cost']
			let _diskSize = ''
			if ('total' in this.planInfo.disk)
			{
				_diskSize = ` / <b>${this.planInfo.disk.total} ${this.localeFtc(this.planInfo.disk.for)}</b>`
				_wholeCost = this.vdsBackupData['cost']// * this.planInfo.disk.total
			}
			else if ('value' in this.planInfo.disk)
			{
				_diskSize = ` / <b>${this.planInfo.disk.value} ${this.localeFtc(this.planInfo.disk.for)}</b>`
				_wholeCost = this.vdsBackupData['cost']// * this.planInfo.disk.value
			}

			return this.localeFtc('service/creating_backup_cost <b>main/ruble</b> / <b>{period}</b>{size}')
				.replace('{cost}', Helper.String2Money(Helper.FormatMoney2(_wholeCost, 2)))
				.replace('{period}', this.localeFtc(this.vdsBackupData['period']))
				.replace('{size}', _diskSize)
		},
		// если при создании все поля выключены
		createScheduleEmpty() {
			// если это не создание - кнопка включена
			if (this.backupScheduleMode !== 'create') return false

			// если нет формы - кнопка включена (вообще без разницы)
			if (!this.backupScheduleForm || !this.backupScheduleForm.fields || !this.backupScheduleForm.fields.length)
				return false

			// по умолчанию кнопка выключена
			let _result = true
			this.backupScheduleForm.fields.some(row => {
				if (row && row.length)
				{
					let _found = row.some(field => {
						if (field && field.type === 'boolean' && field.value)
						{
							return true
						}
					})

					// если нашли хотя бы один включенный пункт - кнопка включена
					if (_found)
					{
						_result = false
						return true
					}
				}
			})

			return _result
		}
	},
	//=========================================================================
	// переменные
	//=========================================================================
	data() {
		return {
			localErrorMessage: '',
			// данные как есть
			rawData: null,
			// закешированный список
			cacheData: null,
			// доступ к VDS
			Access: false,
			Error: '',

			// диалог создания
			showCreateModal: false,
			createModalText: '',

			// диалог удаления записи
			showDeleteModal: false,
			deleteModalText: '',
			deleteModalTimer: false,
			deleteModalTimerHandle: false,
			deleteID: null,

			// диалог восстановления
			showRestoreModal: false,
			restoreID: null,
			restoreBodyTextModal: '',

			// даилог переименования
			showRenameBackupDialog: false,
			renameBackupId: false,
			renameBackupValue: '',
			renameBackupField: {
				required: true,
				type: 'text',
				title: 'service/backup',
				_field_name: 'backupName',
				_visible: true,
				_is_short: true,
				_errMsg: '',
				value: ''
			},

			// генерация ссылки на скачивание бэкапа
			showDownloadBackupModal: false,
			downloadBackupID: null,

			// таймер для рефреша при создании
			createTimer: null,

			// данные в виде FormData
			FD: false,
			FD_count: 0,

			// расписания для автоматического бэкапа
			backupScheduleTableTitle: '',
			backupScheduleRows: [],
			backupScheduleMode: 'create',
			showBackupScheduleModal: false,
			backupScheduleForm: null,
			backupScheduleHas: null,

			// расчитанный стиль пунктов меню строки
			cssUl: false,

			// новые данные о бэкапе для текущей ВДС
			vdsBackupData: null
		}
	},
	//=========================================================================
	// компонент создан
	//=========================================================================
	created() {
		this.Access = this.access
		this.Error = this.parentError
	},
	//=========================================================================
	// после того как компонент смонтирован
	//=========================================================================
	mounted() {
		// навешиваем обработчик на нажатие клавиш
		document.addEventListener('keydown', this.keyDownHandler)
		document.addEventListener('click', this.clickHandler)
		// подписка на Push-сообщения
		EventBus.$on('w5-push', this.pushMessageHandler)
	},
	//=========================================================================
	// перед уничтожением компонента
	//=========================================================================
	beforeDestroy() {
		// таймеры
		if (this.createTimer)
		{
			clearTimeout(this.createTimer)
			this.createTimer = null
		}

		// обработчики
		document.removeEventListener('keydown', this.keyDownHandler)
		document.removeEventListener('click', this.clickHandler)
		// отписка от Push-сообщений
		EventBus.$off('w5-push', this.pushMessageHandler)
	},
	//=========================================================================
	// методы компонента
	//=========================================================================
	methods: {
		//---------------------------------------------------------------------
		// есть ли пункты в меню строки
		//---------------------------------------------------------------------
		thereAreItems(row) {
			let _isRestore = this.Access && !row['Status']['loader'] && !row['Status']['timer'] && this.isInField(row['id'])
			let _isRemove = this.Access && !row['Status']['loader'] && !row['Status']['timer']

			return _isRestore || _isRemove
		},
		//---------------------------------------------------------------------
		// обработка клавиш
		//---------------------------------------------------------------------
		keyDownHandler(e) {
			// закрытие диалогов
			if (e.keyCode === 27 && this.active)
			{
				e.preventDefault()

				this.hideCreateModal()
				this.hideBackupScheduleModal()
				this.hideDeleteModal()
				this.hideRestoreModal()
				this.hideRenameBackupDialog()
				this.hideDownloadBackupModal()

				this.clickHandler()
			}
		},
		//---------------------------------------------------------------------
		// обработка кликов по документу
		//---------------------------------------------------------------------
		clickHandler(e) {
			if (this.cacheData && this.cacheData.length)
				this.cacheData.forEach(item => (item['__btnShow'] = false))
		},
		//---------------------------------------------------------------------
		// получение списка снимков VDS
		//---------------------------------------------------------------------
		requestData() {
			// запрос списка бэкапов
			this.requestBackupList()
			// запрос данных формы с пересохранением кеша
			this.$emit('updateData', false)
		},
		//---------------------------------------------------------------------
		// обработчики Push-сообщений
		//---------------------------------------------------------------------
		pushMessageHandler(msg) {
			// проверка - не задано само сообщение
			if (!msg) return
			// вкладка не активна
			if (!this.active) return

			// разобъем сообщение на части
			let _parts = msg.split(' ')

			// проверка корректности
			if (!_parts || _parts.length < 3) return

			// сообщение нужно обработать только если совпадает CRUD
			if (_parts[1] !== 'service') return

			// получим ID
			let _id = _parts[2]
			// если не задан ID - ничего не делаем
			if (!_id) return

			// может быть это ID нашего VDS?
			let _isVds = String(this.vdsId) === String(_id)

			// ищем запись с таким ID в строкe для рендеринга
			let _found = false
			if (this.cacheData && Array.isArray(this.cacheData) && this.cacheData.length)
			{
				_found = this.cacheData.some(item => {
					if (String(item['id']) === String(_id)) return true
				})
			}

			// если это был ID нашего VDS или бэкапа
			if (_isVds || _found)
				this.requestData()
		},
		//---------------------------------------------------------------------
		// получение статуса
		//---------------------------------------------------------------------
		Status(row) {
			// формируем поле расширенного статуса
			let _field = 'status'
			let _extField = 'status_text'
			// готовим ответ
			let _answer = {
				'loader': false,
				'timer': false,
				'status': ''
			}

			// сначала проверяем расширенный статус
			if (row[_extField])
			{
				// значение расширенного статуса
				let _extValue = row[_extField].replace('request/status_processing', '').trim()

				// по умолчанию считаем что это проецсс
				_answer['status'] = this.localeFtc(_extValue).toLowerCase()
				_answer['loader'] = true

				// если это очередь
				if (_extValue.indexOf('request/status_queue') > -1)
				{
					_extValue = _extValue.replace('request/status_queue', '').trim()
					_answer['status'] = this.localeFtc(_extValue).toLowerCase()
					_answer['loader'] = false
					_answer['timer'] = true
				}

				return _answer
			}

			// расширенный статус пуст - смотрим на стандартный статус
			if (row[_field] === null || row[_field] === undefined)
			{
				_answer['status'] = 'unknown'
				return _answer
			}

			let _status = row[_field]
			if (_status.indexOf('service/status_') !== 0)
				_status = 'service/status_' + _status

			_answer['status'] = this.localeFtc(_status).toLowerCase()

			// для отдельных случаев требуется лоадер
			if (row[_field] === 'processing') _answer['loader'] = true

			return _answer
		},
		//---------------------------------------------------------------------
		// бэкап в списке поля
		//---------------------------------------------------------------------
		isInField(id) {
			// сверка с полем формы
			if (!this.cacheData ||
				!this.cacheData.length)
				return false
			/*
			if (!this.backupList ||
				!this.backupList.list ||
				!this.backupList.list.length)
				return false
			*/

			return this.cacheData.some(item => Boolean(String(item['id']) === String(id) && item.active))
			//return this.backupList.list.some(item => Boolean(String(item['id']) === String(id) && item.active && item.enable))
		},
		//---------------------------------------------------------------------
		// есть ли видимые поля в строке
		//---------------------------------------------------------------------
		isVisibleField(row) {
			if (!row) return false
			// по умолчанию не видна
			let _answer = false
			// ищем любое поле с типом не "hidden"
			row.some((item, idx, arr) => {
				// если такое поле есть - значит строка должна быть видима
				if (item && item.type !== 'hidden' && item['_visible'] === true)
				{
					_answer = true
					return true
				}
			})

			// возвращаем результат
			return _answer
		},
		//---------------------------------------------------------------------
		// поменялось поле
		//---------------------------------------------------------------------
		fieldChanged(field) {
			this.showif()
		},
		//---------------------------------------------------------------------
		// поиск поля в formData
		//---------------------------------------------------------------------
		findField(name) {
			// если нет вообще полей
			if (!this.backupScheduleForm.fields) return null

			// поля есть - пробежимся по ним
			let _field = null
			this.backupScheduleForm.fields.some(item => {
				if (item && Array.isArray(item))
				{
					item.some(obj => {
						if (obj && obj['_field_name'] === name)
						{
							_field = obj
							return true
						}
					})

					if (_field) return true
				}
			})

			return _field
		},
		//---------------------------------------------------------------------
		// вычисляем значение "showif" для всех полей
		//---------------------------------------------------------------------
		showif() {
			// бежим по всем полям
			let _rows = this.backupScheduleForm['fields']
			if (!_rows || !Array.isArray(_rows)) return

			// готовим объекты, где собираем значения и выражения
			let _values = {}
			let _expressions = {}

			// бежим по всем полям - собираем значения и выражения
			_rows.forEach((item) => {
				// смотрим только строки которые определены и являются массивами
				if (item && Array.isArray(item))
				{
					item.forEach((field, idx, arr) => {
						// смотрим только поля с названиями
						if (field['_field_name'])
						{
							// заполняем объект со значениями
							_values[field['_field_name'].replace(/\[/g, '__').replace(/]/g, '__')] = field['value']

							// если есть выражение для данного поля
							if (field['showif'])
							{
								// получим выражение
								let _expr = field['showif']
								// подменяем в выражении переменные
								if (_expr.indexOf('[') !== -1 && _expr.indexOf(']') !== -1 && _expr.indexOf(' in ') !== -1)
								{
									// условие: var not in [array]
									if (_expr.indexOf(' not in ') !== -1)
									{
										// var not in [1,2,3,4,5] => w5InArray(var, [1,2,3,4,5]) < 0
										let reg = new RegExp(/(\w+) not in (\[[',0-9\s\w]+\])/gi)

										// проверяем
										if (reg.exec(_expr) !== null)
										{
											_expr = _expr.replace(reg, 'w5InArray($1, $2) < 0')
										}
										else
										{
											// var[idx] not in [1,2,3,4,5] => w5InArray(var__idx__, [1,2,3,4,5]) < 0
											reg = new RegExp(/(\w+\[\w+\]) not in (\[[',\w\s]+\])/i)
											let _mtch = null
											if ((_mtch = reg.exec(_expr)) !== null)
											{
												_expr = _expr.replace(_mtch[0], 'w5InArray(' +
													_mtch[1].replace(/\[/g, '__').replace(/]/g, '__') +
													', ' +
													_mtch[2] +
													') < 0')
											}
										}
									}
									// условие: var in [array]
									else
									{
										// var in [1,2,3,4,5] => w5InArray(var, [1,2,3,4,5])
										let reg = new RegExp(/(\w+) in (\[[',0-9\s\w]+\])/gi)

										// проверяем
										if (reg.exec(_expr) !== null)
										{
											_expr = _expr.replace(reg, 'w5InArray($1, $2) !== -1')
										}
										else
										{
											// var[idx] in [1,2,3,4,5] => w5InArray(var__idx__, [1,2,3,4,5])
											reg = new RegExp(/(\w+\[\w+\]) in (\[[',\w\s]+\])/i)
											let _mtch = null
											if ((_mtch = reg.exec(_expr)) !== null)
											{
												_expr = _expr.replace(_mtch[0], 'w5InArray(' +
													_mtch[1].replace(/\[/g, '__').replace(/]/g, '__') +
													', ' +
													_mtch[2] +
													') !== -1')
											}
										}
									}
								}
								// type[period] == 0    =>    type__period__ == 0
								else _expr = _expr.replace(/\[/g, '__').replace(/]/g, '__')
								_expressions[field['_field_name']] = _expr
							}
						}
					})
				}
			})

			// теперь бежим по всем полученным выражениям
			for (let e in _expressions)
			{
				// подменяем поля на свойства объекта
				let _exp = _expressions[e]
				for (let v in _values)
				{
					let reg = new RegExp('\\b' + v + '\\b', 'gi')
					_exp = _exp.replace(reg, (str, offset, src) => {
						// если в начале строки - это точно поле
						if (offset <= 0) return 'obj.' + v
						// если не в начале, и сразу перед ним стоит кавычка - это точно не поле
						else if (src.charAt(offset - 1) === '\'' || src.charAt(offset - 1) === '"') return v
						// по умолчанию это все таки поле
						return 'obj.' + v
					})
				}

				// формируем функцию
				// eslint-disable-next-line
				let _func = new Function('obj', ' return ' + _exp)

				// ищем поле
				let _field = this.findField(e)
				if (_field)
				{
					// обнулим ошибку в любом случае
					this.$set(_field, '_errMsg', '')
					// установим видимость поля
					this.$set(_field, '_visible', _func(_values))
				}
			}
		},
		//---------------------------------------------------------------------
		// локальная проверка полей
		//---------------------------------------------------------------------
		localValidation(field) {
			// проверяем только определенные типы
			// если поле невидно - то и проверять нет смысла, передаваться будет как есть
			if (!field['_visible']) return true
			// если значение поля не задано - то и проверять нет смысла, передаваться будет как есть
			if (field['value'] === undefined || field['value'] === null) return true

			// INTEGRE
			if (field.type === 'integer' || field.type === 'int')
			{
				// получим значение в виде строки
				let v = String(field.value).trim()
				// уберем пробелы
				v = v.replace(/ /g, '')
				// парсим в INT
				let r = parseInt(v)
				// если не удалось
				if (isNaN(r))
				{
					field['_errMsg'] = 'validators/error_int'
					return false
				}

				// если значение не изменилось
				if (v === String(r)) return true
				// значение изменилось
				field['_errMsg'] = 'validators/error_int'
				return false
			}

			// FLOAT || MONEY
			if (field.type === 'float' || field.type === 'money')
			{
				// получим значение в виде строки
				let v = String(field.value).trim()
				// уберем пробелы
				v = v.replace(/ /g, '')
				// парсим в FLOAT
				let r = parseFloat(v)
				// если не удалось
				if (isNaN(r))
				{
					field['_errMsg'] = 'validators/error_float'
					return false
				}

				// доп.проверка
				if (!Helper.isNumeric(String(r)))
				{
					// значение не число
					field['_errMsg'] = 'validators/error_float'
					return false
				}
			}

			// EMAIL
			if (field.type === 'email')
			{
				if (Helper.validateEmail(field.value)) return true
				// проверка не пройдена
				field['_errMsg'] = 'validators/error_email'
				return false
			}

			// для остальных типов все ОК
			return true
		},
		//---------------------------------------------------------------------
		// конвертация данных в FormData
		//---------------------------------------------------------------------
		FD_prepare: function(d, key) {
			let k

			for (k in d) if (d.hasOwnProperty(k))
			{
				// если пересылают файл в форме - патч для safari 10+
				if (d[k] && key &&
					k === 'file' &&
					typeof d[k] === 'object' &&
					'name' in d[k] &&
					'size' in d[k] &&
					'type' in d[k])
				{
					this.FD.append(key + '[' + k + ']', d[k])
					this.FD_count++
					continue
				}

				// остальные поля обрабатываем по старому
				if (typeof d[k] === 'object' && d[k] && !('lastModifiedDate' in d[k]))
				{
					if (key)
					{
						this.FD_prepare(d[k], key + '[' + k + ']')
					}
					else
					{
						this.FD_prepare(d[k], k)
					}
				}
				else
				{
					if (key)
					{
						this.FD.append(key + '[' + k + ']', d[k])
					}
					else
					{
						this.FD.append(k, d[k])
					}

					this.FD_count++
				}
			}
		},
		//---------------------------------------------------------------------
		// данные о стоимосте бэкапа текущей ВДС
		//---------------------------------------------------------------------
		getVdsBackupData() {
			this.vdsBackupData = null
			if (!this.vdsId) return

			if (this.vdsInfo &&
				this.vdsInfo.service &&
				this.vdsInfo.service.backup &&
				'cost' in this.vdsInfo.service.backup)
			{
				this.vdsBackupData = Object.assign({}, this.vdsInfo.service.backup)
				return
			}

			let _url = this.APIServerUrl + '/service/create?search=service_backup'
			if (this.$store.state.user_type === 'admin' &&
				this.account &&
				this.account.account_id &&
				'value' in this.account.account_id)
			{
				_url += '&account_id=' + this.account.account_id.value
			}

			this.$http.get(_url)
			.then(res => {
				// получаем ответ
				let _dt = res && res.data && typeof res.data === 'object' ? res.data : false
				// если ответ корректный
				if (_dt && _dt['status'] === 'ok' && _dt['result'] && _dt['result'].length)
				{
					for (let i = 0; i < _dt['result'].length; i++)
					{
						if (String(_dt['result'][i]['id']) === String(this.vdsId))
						{
							this.vdsBackupData = _dt['result'][i]
							break
						}
					}
				}
			})
			.catch(() => {})
		},
		//---------------------------------------------------------------------
		// список бэкапов
		//---------------------------------------------------------------------
		requestBackupList() {
			if (!this.vdsId) return

			let _url = this.APIServerUrl + '/service/update/' + this.vdsId + '?search=backup'

			this.$http.get(_url)
			.then(res => {
				// получаем ответ
				let _dt = res && res.data && typeof res.data === 'object' ? res.data : false
				// если ответ корректный
				if (_dt && _dt['status'] === 'ok')
				{
					this.cacheData = []

					if (this.active && _dt['result'] && _dt['result'].length)
					{
						const newList = _dt['result']
						for (let i = 0; i < newList.length; i++)
						{
							// активный
							if (!newList[i] || newList[i].enable !== true)
							{
								continue
							}

							// получим строку
							let _row = Object.assign({}, newList[i])
							// добавим свой статус
							_row['Status'] = this.Status(newList[i])
							// добавим признак - показ кнопки
							_row['__btnShow'] = false

							// добавим
							this.cacheData.push(_row)
						}

						// отсортируем по дате создания
						this.cacheData.sort(Helper.naturalCompareObjectField('created', 0))
					}
				}
			})
			.catch(() => {})
		},
		//---------------------------------------------------------------------
		// автоматические расписания
		//---------------------------------------------------------------------
		refreshBackupSchedule() {
			// если неизвестен ID vds
			if (!this.vdsId) return

			// проверим соответствующий флаг
			if (this.vdsInfo &&
				this.vdsInfo.service &&
				this.vdsInfo.service.service_data &&
				this.vdsInfo.service.service_data.value &&
				'has_schedule' in this.vdsInfo.service.service_data.value)
			{
				this.backupScheduleHas = Helper.normalizeBooleanValue(this.vdsInfo.service.service_data.value.has_schedule)
			}
		},
		// получение расписяни автоматического бэкапа
		requestBackupSchedule() {
			this.$emit('requestData')
			/*
			let _url = this.APIServerUrl + '/backupschedule/view/' + this.vdsId

			this.$http.get(_url)
			.then(res => {
				// получаем ответ
				let _dt = res && res.data && typeof res.data === 'object' ? res.data : false
				// если ответ корректный
				if (_dt && _dt['status'] === 'ok')
				{
					if (_dt['rows'] && _dt['rows'].length && _dt['title'])
					{
						this.backupScheduleRows = _dt['rows']
						this.backupScheduleTableTitle = _dt['title']
					}
					else
					{
						this.backupScheduleRows = []
						this.backupScheduleTableTitle = ''
					}
				}
			})
			.catch(() => {})
			*/
		},
		// удаление
		deleteBackupSchedule() {
			// проверка доступа
			if (!this.Access || this.Error) return

			// обнулим ошибку
			this.localErrorMessage = ''
			this.deleteModalText = ''
			this.deleteID = null

			// проверки
			if (!this.vdsId)
			{
				this.localErrorMessage = 'error/app_internal'
				return
			}

			// проверка прав доступа
			if (!this.isAccess('backupschedule/delete'))
			{
				this.localErrorMessage = 'main/access_denied'
				return
			}

			// формируем вопрос
			this.deleteModalText = this.localeFtc('main/delete') + ' ' + this.localeFtc('schedule/backup').toLowerCase() + '?'

			// запоминаем ID
			this.deleteID = 'schedule'
			// таймер
			this.deleteModalTimer = 5
			// можно показывать диалог
			EventBus.$emit('w5-body-scroll-disable')
			this.showDeleteModal = true
			// запускаем таймер
			this.deleteModalTimerHandle = setInterval(() => {
				this.deleteModalTimer--
				if (this.deleteModalTimer <= 0)
				{
					clearInterval(this.deleteModalTimerHandle)
					this.deleteModalTimerHandle = false
				}
			}, 1000)
		},
		// сам процесс удаления
		deleteBackupScheduleBegin() {
			// данные собраны - отправляем их
			let _url = '/backupschedule/delete/' + this.vdsId
			this.$http.get(this.APIServerUrl + _url)
			.then(resGet => {
				// получаем ответ
				let _dt = resGet && resGet.data && typeof resGet.data === 'object' ? resGet.data : false
				// если ответ корректный
				if (_dt && _dt['_csrf'])
					return _dt['_csrf']

				throw new Error(_dt)
			})
			.then(csrf => {
				// производим сам запрос
				this.$http.post(this.APIServerUrl + _url, Helper.toFormData({ _csrf: csrf })).then(
					// успешный ответ сервера
					resPost => {
						// данные
						let _dt = resPost && resPost.data && typeof resPost.data === 'object' ? resPost.data : false
						// если ошибки нет
						if (_dt && _dt['status'] === 'ok')
						{
							this.requestBackupSchedule()
							return
						}

						// иная ошибка
						this.localErrorMessage = this.formatRequestError(resPost)
					},
					// отрицательный ответ сервера
					resPost => {
						this.localErrorMessage = this.formatRequestError(resPost)
					}
				)
			})
			.catch(error => {
				this.localErrorMessage = this.formatRequestError(error)
			})
		},
		// скрыть диалога создания/правки
		hideBackupScheduleModal() {
			EventBus.$emit('w5-body-scroll-enable')
			this.showBackupScheduleModal = false
			this.hideModalMask()
		},
		// редактирование расписания
		updateBackupSchedule() {
			// проверка доступа
			if (!this.Access || this.Error) return
			if (!this.vdsId || !this.isAccess('backupschedule/update')) return

			// всегда запрашиваем свежую форму
			this.backupScheduleMode = 'update'
			this.backupScheduleForm = null
			let _url = this.APIServerUrl + '/backupschedule/update/' + this.vdsId

			this.$http.get(_url)
			.then(
				resGet => {
					// получаем ответ
					let _dt = resGet && resGet.data && typeof resGet.data === 'object' ? resGet.data : false
					// если ответ корректный
					if (_dt && _dt['status'] === 'form')
					{
						this.backupScheduleForm = this.parseFormData(_dt)
						this.$nextTick(() => {
							this.showif()
						})
						// показываем диалог
						EventBus.$emit('w5-body-scroll-disable')
						this.showBackupScheduleModal = true
					}
				},
				resGet => {
					this.localErrorMessage = this.formatRequestError(resGet)
				}
			)
		},
		// создание нового
		createBackupSchedule() {
			// проверка доступа
			if (!this.Access || this.Error) return
			if (!this.vdsId || !this.isAccess('backupschedule/create')) return

			// всегда запрашиваем свежую форму
			this.backupScheduleForm = null
			this.backupScheduleMode = 'create'
			let _url = this.APIServerUrl + '/backupschedule/create/' + this.vdsId

			this.$http.get(_url)
			.then(
				resGet => {
					// получаем ответ
					let _dt = resGet && resGet.data && typeof resGet.data === 'object' ? resGet.data : false
					// если ответ корректный
					if (_dt && _dt['status'] === 'form')
					{
						this.backupScheduleForm = this.parseFormData(_dt)
						this.$nextTick(() => {
							this.showif()
						})

						// показываем диалог
						EventBus.$emit('w5-body-scroll-disable')
						this.showBackupScheduleModal = true
					}
				},
				resGet => {
					this.localErrorMessage = this.formatRequestError(resGet)
				}
			)
		},
		// начало процесса
		createBackupScheduleBegin() {
			// проверка доступа
			if (!this.Access || this.Error) return

			// проверка кнопки
			if (this.createScheduleEmpty) return

			// обнулим ошибку
			this.localErrorMessage = ''

			// проверки
			if (!this.vdsId)
			{
				this.localErrorMessage = 'error/app_internal'
				this.hideBackupScheduleModal()
				return
			}

			// проверка прав доступа
			let _access = true
			if (this.backupScheduleMode === 'create')
				_access = this.isAccess('backupschedule/create')
			else
				_access = this.isAccess('backupschedule/update')

			// если доступа нет
			if (!_access)
			{
				this.localErrorMessage = 'main/access_denied'
				this.hideBackupScheduleModal()
				return
			}

			// бежим по всем полям
			let _rows = this.backupScheduleForm['fields']

			// если полей нет
			if (!_rows || !Array.isArray(_rows))
			{
				this.localErrorMessage = 'error/app_internal'
				this.hideBackupScheduleModal()
				return
			}

			let _data = this.collectFormData(_rows, this.localValidation)
			// если данные по каким либо причинам собрать не удалось
			if (_data === false) return

			// можем закрыть диалог
			this.hideBackupScheduleModal()

			// данные собраны - отправляем их
			let _url = '/backupschedule/' + this.backupScheduleMode + '/' + this.vdsId
			this.$http.get(this.APIServerUrl + _url)
			.then(resGet => {
				// получаем ответ
				let _dt = resGet && resGet.data && typeof resGet.data === 'object' ? resGet.data : false
				// если ответ корректный
				if (_dt && _dt['status'] === 'form' && _dt['_csrf'] && _dt['model'])
				{
					return { csrf: _dt['_csrf'], model: _dt['model'] }
				}

				throw new Error(_dt)
			})
			.then(getDate => {
				_data = this.FormDataRePack(_data)

				// готовим данные
				let _post = {
					'_csrf': getDate.csrf
				}
				_post[getDate.model] = _data

				// готовим данные в виде FormData
				this.FD = new FormData()
				this.FD_count = 0
				this.FD_prepare(_post)

				// производим сам запрос
				this.$http.post(this.APIServerUrl + _url, this.FD_count > 0 ? this.FD : null).then(
					// успешный ответ сервера
					resPost => {
						// данные
						let _dt = resPost && resPost.data && typeof resPost.data === 'object' ? resPost.data : false
						// если ошибки нет
						if (_dt && _dt['status'] === 'ok')
						{
							this.$emit('successMessage', this.backupScheduleMode === 'create' ? 'schedule/created' : 'schedule/updated')
							this.backupScheduleHas = null
							this.requestBackupSchedule()
							return
						}

						// иная ошибка
						this.localErrorMessage = this.formatRequestError(resPost)
					},
					// отрицательный ответ сервера
					resPost => {
						this.localErrorMessage = this.formatRequestError(resPost)
					}
				)
			})
			.catch(error => {
				this.localErrorMessage = this.formatRequestError(error)
			})
		},
		//---------------------------------------------------------------------
		// создание нового
		//---------------------------------------------------------------------
		// показ диалога
		createBackup() {
			// проверка доступа
			if (!this.Access || !this.vdsBackupData || this.Error) return
			// обнулим сообщения
			this.localErrorMessage = ''
			this.createModalText = this.localeFtc('service/creating_backup_confirm')

			// нужно запросить данные о стоимости
			if (this.vdsBackupData && this.vdsBackupData['cost'] > 0)
			{
				let _wholeCost = this.vdsBackupData['cost']
				let _diskSize = ''
				if (this.planInfo && this.planInfo.disk && 'total' in this.planInfo.disk)
				{
					_diskSize = ` / <b>${this.planInfo.disk.total} ${this.localeFtc(this.planInfo.disk.for)}</b>`
					_wholeCost = this.vdsBackupData['cost']// * this.planInfo.disk.total
				}
				else if (this.planInfo && this.planInfo.disk && 'value' in this.planInfo.disk)
				{
					_diskSize = ` / <b>${this.planInfo.disk.value} ${this.localeFtc(this.planInfo.disk.for)}</b>`
					_wholeCost = this.vdsBackupData['cost']// * this.planInfo.disk.value
				}

				this.createModalText = this.localeFtc('service/creating_backup_confirm <br> service/creating_backup_cost <b>main/ruble</b> / <b>{period}</b>{size}')
					.replace('{cost}', this.moneyOnlyNumbers(_wholeCost))
					.replace('{period}', this.localeFtc(this.vdsBackupData['period']))
					.replace('{size}', _diskSize)
			}

			// можно показывать диалог
			EventBus.$emit('w5-body-scroll-disable')
			this.showCreateModal = true
		},
		// непосредственно - создание снимка
		createBackupBegin() {
			// проверка доступа
			if (!this.Access || !this.vdsBackupData || this.Error) return
			// чистим сообщения
			this.localErrorMessage = ''
			// сразу скрываем диалог
			this.hideCreateModal()
			// все в порядке - формируем URL
			let _url = this.APIServerUrl + '/service/create/' + Vue.Constants.SERVICE_TYPE_BACKUP_VDS
			// начинаем двойной запрос
			this.$http.get(_url).then(
				// положительный ответ
				resGet => {
					// получаем ответ
					let _dt = resGet && resGet.data && typeof resGet.data === 'object' ? resGet.data : false
					// если ответ корректный
					if (_dt && _dt['_csrf'] && _dt['model'] && _dt['status'] === 'form')
					{
						// формируем POST-параметры
						let _post = { '_csrf': _dt['_csrf'] }

						// получим аккаунт
						let _account = null
						if (this.account &&
							this.account.account_id &&
							'value' in this.account.account_id)
						{
							_account = this.account.account_id.value
						}
						if (!_account)
						{
							if (_dt['fields'] && _dt['fields']['account_id'] && _dt['fields']['account_id']['value'])
							{
								_account = _dt['fields']['account_id']['value']
							}
						}
						if (!_account && this.$store.state.user_account)
						{
							_account = String(this.$store.state.user_account).replace(/[a-z]/ig, '')
						}

						// формируем данные формы
						_post[_dt['model']] = {
							'service_id': this.vdsId,
							'account_id': _account,
							'reinstall': 0
						}

						// производим запрос POST
						this.$http.post(_url, Helper.toFormData(_post)).then(
							// успешный ответ сервера
							resPost => {
								_dt = resPost && resPost.data && typeof resPost.data === 'object' ? resPost.data : false
								// если ошибки нет
								if (_dt && _dt['status'] === 'ok')
								{
									// установим успешное сообщение
									this.$emit('successMessage', 'service/creating_backup_begin_process')
									// отменяем прежний временной отрезок
									if (this.createTimer)
									{
										clearTimeout(this.createTimer)
										this.createTimer = null
									}
									// заряжаем таймер на 2 секунды
									this.createTimer = setTimeout(() => this.requestData(), 2000)
									// на этом все
									return
								}

								// иная ошибка
								this.localErrorMessage = this.formatRequestError(resPost)
							},
							// отрицательный ответ сервера
							resPost => {
								// ошибка сервера
								this.localErrorMessage = this.formatRequestError(resPost)
							}
						)

						// на этом все
						return
					}

					// ошибка формата ответа
					this.localErrorMessage = this.formatRequestError(resGet)
				},
				// отрицательный ответ
				resGet => {
					// ошибка сервера
					this.localErrorMessage = this.formatRequestError(resGet)
				}
			)
		},
		//---------------------------------------------------------------------
		// удаление
		//---------------------------------------------------------------------
		deleteBackup(id) {
			// проверка доступа
			if (!this.Access || this.Error) return
			// обнулим сообщения
			this.localErrorMessage = ''
			this.deleteModalText = ''
			this.deleteID = null

			// нужно найти запись с данным ID
			let _name = false
			this.cacheData.some(item => {
				if (String(item['id']) === String(id))
				{
					_name = this.localeFtc(item['full_name'])
					return true
				}
			})

			// если такой снимок уже не найден
			if (!_name) return

			// формируем вопрос
			this.deleteModalText = this.localeFtc('service/deleting_backup_confirm')
				.replace('{name}', _name)

			// закроем все открытые меню
			this.toggleMenu('off')

			// запоминаем ID
			this.deleteID = id
			// таймер
			this.deleteModalTimer = 5
			// можно показывать диалог
			EventBus.$emit('w5-body-scroll-disable')
			this.showDeleteModal = true
			// запускаем таймер
			this.deleteModalTimerHandle = setInterval(() => {
				this.deleteModalTimer--
				if (this.deleteModalTimer <= 0)
				{
					clearInterval(this.deleteModalTimerHandle)
					this.deleteModalTimerHandle = false
				}
			}, 1000)
		},
		// установка статуса для записи с заданным ID
		restoreStatus(id, status) {
			this.cacheData.some((item, idx, arr) => {
				if (String(item['id']) === String(id))
				{
					arr[idx]['Status'] = status
					return true
				}
			})
		},
		// старт процесса удаления
		deleteBackupBegin() {
			// проверка таймера
			if (this.deleteModalTimer && this.deleteModalTimer > 0) return
			// проверка доступа
			if (!this.Access || this.Error) return
			// обнулим сообщения
			this.localErrorMessage = ''
			// если не задан ID
			if (!this.deleteID) return

			// сразу скрываем диалог
			this.hideDeleteModal()

			// если это удаление расписания
			if (this.deleteID === 'schedule')
			{
				this.deleteBackupScheduleBegin()
				return
			}

			// сразу скроем все кнопки
			let _oldStatus = null
			// ищем строку по ID
			this.cacheData.some((item, idx, arr) => {
				if (String(item['id']) === String(this.deleteID))
				{
					_oldStatus = item['Status']
					arr[idx]['Status'] = { loader: true, status: this.localeFtc('main/deleting') }
					return true
				}
			})

			// все в порядке - формируем URL
			let _url = this.APIServerUrl + '/service/delete/' + this.deleteID
			// начинаем двойной запрос
			this.$http.get(_url).then(
				// положительный ответ
				resGet => {
					// получаем ответ
					let _dt = resGet && resGet.data && typeof resGet.data === 'object' ? resGet.data : false
					// если ответ корректный
					if (_dt && _dt['_csrf'])
					{
						// формируем POST-параметры
						let _post = { '_csrf': _dt['_csrf'] }
						// производим запрос POST
						this.$http.post(_url, Helper.toFormData(_post)).then(
							// успешный ответ сервера
							resPost => {
								_dt = resPost && resPost.data && typeof resPost.data === 'object' ? resPost.data : false
								// если ошибки нет
								if (_dt && _dt['status'] === 'ok')
								{
									// установим успешное сообщение
									this.$emit('successMessage', 'service/deleting_backup_begin_process')
									// на этом все
									return
								}

								// вернем значение кнопок
								if (_oldStatus) this.restoreStatus(this.deleteID, _oldStatus)
								// иная ошибка
								this.localErrorMessage = this.formatRequestError(resPost)
							},
							// отрицательный ответ сервера
							resPost => {
								// вернем значение кнопок
								if (_oldStatus) this.restoreStatus(this.deleteID, _oldStatus)
								// ошибка сервера
								this.localErrorMessage = this.formatRequestError(resPost)
							}
						)

						// на этом все
						return
					}

					// вернем значение кнопок
					if (_oldStatus) this.restoreStatus(this.deleteID, _oldStatus)
					// ошибка формата ответа
					this.localErrorMessage = this.formatRequestError(resGet)
				},
				// отрицательный ответ
				resGet => {
					// вернем значение кнопок
					if (_oldStatus) this.restoreStatus(this.deleteID, _oldStatus)
					// ошибка сервера
					this.localErrorMessage = this.formatRequestError(resGet)
				}
			)
		},
		//---------------------------------------------------------------------
		// восстановление
		//---------------------------------------------------------------------
		restoreBackup(id) {
			// проверка доступа
			if (!this.Access || this.Error) return
			// обнулим сообщения
			this.localErrorMessage = ''
			this.restoreID = null

			// название бэкапа
			let backupName = ''

			// нужно найти запись с данным ID
			this.cacheData.some(item => {
				if (String(item['id']) === String(id))
				{
					this.restoreID = item['id']
					backupName = item['full_name']
					return true
				}
			})
			// если такой снимок уже не найден
			if (!this.restoreID) return

			// сверка с полем формы
			/*
			if (!this.backupList ||
				!this.backupList.list ||
				!this.backupList.list.length ||
				!this.backupList.list.some(item => String(item['id']) === String(id)))
				return
			*/

			// закроем все открытые меню
			this.toggleMenu('off')

			// проставим текст диалога
			this.restoreBodyTextModal = this.localeFtc('service/restore_backup_info')
				.replace('{server}', this.vdsName)
				.replace('{backup}', backupName)

			// можно показывать диалог
			EventBus.$emit('w5-body-scroll-disable')
			this.showRestoreModal = true
		},
		hideRestoreModal() {
			EventBus.$emit('w5-body-scroll-enable')
			this.showRestoreModal = false
			this.hideModalMask()
		},
		restoreBackupBegin() {
			// проверка доступа
			if (!this.Access || this.Error) return
			// проверка основных данных
			if (!this.restoreID) return
			// обнулим сообщения
			this.localErrorMessage = ''
			// сразу скроем диалог
			this.hideRestoreModal()
			// сразу скроем все кнопки
			let _oldStatus = null
			// ищем строку по ID
			this.cacheData.some((item, idx, arr) => {
				if (String(item['id']) === String(this.restoreID))
				{
					_oldStatus = item['Status']
					arr[idx]['Status'] = { loader: true, status: this.localeFtc('service/restore') }
					return true
				}
			})
			//~ ~ ~ ~ ~ ~ ~ ~ ~ ~ ~ ~ ~ ~ ~ ~ ~ ~ ~ ~ ~ ~ ~ ~ ~ ~ ~ ~ ~ ~ ~ ~ ~
			// начинаем двойной запрос
			//~ ~ ~ ~ ~ ~ ~ ~ ~ ~ ~ ~ ~ ~ ~ ~ ~ ~ ~ ~ ~ ~ ~ ~ ~ ~ ~ ~ ~ ~ ~ ~ ~
			let _url = this.APIServerUrl +
				'/service/update/' +
				this.vdsId +
				'?additional=setRestore&service_id=' +
				this.restoreID

			this.$http.get(_url).then(
				// положительный ответ
				resGet => {
					// получаем ответ
					let _dt = resGet && resGet.data && typeof resGet.data === 'object' ? resGet.data : false
					// если ответ корректный
					if (_dt && _dt['_csrf'] && _dt['status'])
					{
						// формируем POST-параметры
						let _post = { '_csrf': _dt['_csrf'] }

						// производим запрос POST
						this.$http.post(_url, Helper.toFormData(_post)).then(
							// успешный ответ сервера
							resPost => {
								_dt = resPost && resPost.data && typeof resPost.data === 'object' ? resPost.data : false
								// если ошибки нет
								if (_dt && _dt['status'] === 'ok')
								{
									// установим успешное сообщение
									this.$emit('successMessage', 'service/restore_queued')
									// на этом все
									return
								}

								// вернем значение кнопок
								if (_oldStatus) this.restoreStatus(this.restoreID, _oldStatus)
								// иная ошибка
								this.localErrorMessage = this.formatRequestError(resPost)
							},
							// отрицательный ответ сервера
							resPost => {
								// вернем значение кнопок
								if (_oldStatus) this.restoreStatus(this.restoreID, _oldStatus)
								// ошибка сервера
								this.localErrorMessage = this.formatRequestError(resPost)
							}
						)

						// на этом все
						return
					}

					// вернем значение кнопок
					if (_oldStatus) this.restoreStatus(this.restoreID, _oldStatus)
					// ошибка формата ответа
					this.localErrorMessage = this.formatRequestError(resGet)
				},
				// отрицательный ответ
				resGet => {
					// вернем значение кнопок
					if (_oldStatus) this.restoreStatus(this.restoreID, _oldStatus)
					// ошибка сервера
					this.localErrorMessage = this.formatRequestError(resGet)
				}
			)

			//~ ~ ~ ~ ~ ~ ~ ~ ~ ~ ~ ~ ~ ~ ~ ~ ~ ~ ~ ~ ~ ~ ~ ~ ~ ~ ~ ~ ~ ~ ~ ~ ~
		},
		//---------------------------------------------------------------------
		// создание VDS из бэкапа
		//---------------------------------------------------------------------
		createFromBackup(data) {
			// проверка
			if (!window || !window.sessionStorage || !data || !data.id) return
			// формируем данные
			let _store = {
				service_id: data.id
			}
			if (data.account_id)
				_store.account_id = data.account_id
			// сохраним в сессии
			window.sessionStorage.setItem('create-vds-from-backup', JSON.stringify(_store))
			// переход в форму создания
			this.$router.push('/vds/create')
		},
		//---------------------------------------------------------------------
		// функция закрывает модальный диалог создания ссылки на скачивание бэкапа
		//---------------------------------------------------------------------
		hideDownloadBackupModal() {
			EventBus.$emit('w5-body-scroll-enable')
			this.showDownloadBackupModal = false
			this.hideModalMask()
		},
		//---------------------------------------------------------------------
		// генерация ссылки на скачивания бэкапа
		//---------------------------------------------------------------------
		downloadBackup(row) {
			// отключили 12.2023
			if (row) return

			this.localErrorMessage = ''

			// получим ID Записи
			let _id = row['id']
			if (!_id) return

			// если статус не тот
			if (row['status'] !== 'active' || row['status_text']) return

			// если нет прав
			if (!this.isAccess('service/update')) return

			// получим ID услуги
			let _serviceID = parseInt(_id)
			if (isNaN(_serviceID) || _serviceID <= 0) return
			this.downloadBackupID = _serviceID

			// закроем все открытые меню
			this.toggleMenu('off')

			// показываем диалог
			EventBus.$emit('w5-body-scroll-disable')
			this.showDownloadBackupModal = true
		},
		//---------------------------------------------------------------------
		// копирование бэкапа - сам запрос
		//---------------------------------------------------------------------
		downloadBackupProcessStart() {
			this.localErrorMessage = ''

			// если не выбран ID услуги
			if (!this.downloadBackupID) return

			// если нет прав
			if (!this.isAccess('service/update')) return

			// закроем диалог
			this.hideDownloadBackupModal()

			// формируем URL
			let _url = this.APIServerUrl + '/service/update/' + this.downloadBackupID + '?additional=setDownload'

			// начинаем двойной запрос
			this.$http.get(_url).then(
				// положительный ответ
				resGet => {
					// получаем ответ
					let _dt = resGet && resGet.data && typeof resGet.data === 'object' ? resGet.data : false
					// если ответ корректный
					if (_dt && _dt['_csrf'])
					{
						// производим запрос POST
						this.$http.post(_url, Helper.toFormData({ '_csrf': _dt['_csrf'] })).then(
							// успешный ответ сервера
							resPost => {
								// получим ответ
								_dt = resPost && resPost.data && typeof resPost.data === 'object' ? resPost.data : false
								// если ошибки нет
								if (_dt && _dt['status'] === 'ok')
								{
									// установим успешное сообщение
									this.$emit('successMessage', 'service/download_queued')
									// обновляем список
									this.requestData()
									return
								}

								// иная ошибка
								this.localErrorMessage = this.formatRequestError(resPost)
							},
							// отрицательный ответ сервера
							resPost => {
								this.localErrorMessage = this.formatRequestError(resPost)
							}
						)

						// на этом все
						return
					}

					// ошибка формата ответа
					this.localErrorMessage = this.formatRequestError(resGet)
				},
				// отрицательный ответ
				resGet => {
					this.localErrorMessage = this.formatRequestError(resGet)
				}
			)
		},
		//---------------------------------------------------------------------
		// диалог переименования бэкапа
		//---------------------------------------------------------------------
		// закрыть диалог
		hideRenameBackupDialog() {
			EventBus.$emit('w5-body-scroll-enable')
			this.showRenameBackupDialog = false
			this.hideModalMask()
		},
		// enter на поле
		renameBackupKeyDown(e) {
			if (e) e.preventDefault()
			this.renameBackupStart()
		},
		// переименование бэкапа - показ диалога
		renameBackup(data) {
			// отключили 12.2023
			if (data) return

			// проверка входных параметров
			if (!data) return

			// получим ID Записи
			let _id = data['id']
			if (!_id) return

			// проверка
			if (data['status'] !== 'active' || data['status_text']) return

			// данные
			this.renameBackupId = _id
			this.renameBackupValue = data['name']

			// закроем все открытые меню
			this.toggleMenu('off')

			// показываем диалог
			EventBus.$emit('w5-body-scroll-disable')
			this.showRenameBackupDialog = true
		},
		// начать процесс бэкапа/восстановления
		renameBackupStart() {
			// проверки
			if (!this.renameBackupId) return
			if (!this.isAccess('service/update')) return

			if (!this.renameBackupValue)
			{
				this.renameBackupField._errMsg = 'error/required_field'
				return
			}

			// можно закрывать диалог
			this.hideRenameBackupDialog()

			// обнулим сообщения
			this.localErrorMessage = ''

			// сразу скроем все кнопки
			let _oldStatus = null
			// ищем строку по ID
			this.cacheData.some((item, idx, arr) => {
				if (String(item['id']) === String(this.restoreID))
				{
					_oldStatus = item['Status']
					arr[idx]['Status'] = { loader: true, status: this.localeFtc('service/rename_action') }
					return true
				}
			})

			// все в порядке - формируем URL
			let _url = this.APIServerUrl + '/service/update/' + this.renameBackupId

			// начинаем двойной запрос
			this.$http.get(_url).then(
				// положительный ответ
				resGet => {
					// получаем ответ
					let _dt = resGet && resGet.data && typeof resGet.data === 'object' ? resGet.data : false

					// если ответ корректный
					if (_dt && _dt['_csrf'] && _dt['model'] && _dt['status'] === 'form')
					{
						// формируем POST-параметры
						let _post = { '_csrf': _dt['_csrf'] }
						_post[_dt['model']] = {
							'name': this.renameBackupValue
						}

						// производим запрос POST
						this.$http.post(_url, Helper.toFormData(_post)).then(
							// успешный ответ сервера
							resPost => {
								_dt = resPost && resPost.data && typeof resPost.data === 'object' ? resPost.data : false
								// если ошибки нет
								if (_dt && _dt['status'] === 'ok')
								{
									// установим успешное сообщение
									this.$emit('successMessage', 'forget/success')
									// обновляем список
									this.requestData()
									// на этом все
									return
								}

								// вернем значение кнопок
								if (_oldStatus) this.restoreStatus(this.renameBackupId, _oldStatus)
								// иная ошибка
								this.localErrorMessage = this.formatRequestError(resPost)
							},
							// отрицательный ответ сервера
							resPost => {
								// вернем значение кнопок
								if (_oldStatus) this.restoreStatus(this.renameBackupId, _oldStatus)
								// ошибка сервера
								this.localErrorMessage = this.formatRequestError(resPost)
							}
						)
						// на этом все
						return
					}

					// вернем значение кнопок
					if (_oldStatus) this.restoreStatus(this.renameBackupId, _oldStatus)
					// ошибка формата ответа
					this.localErrorMessage = this.formatRequestError(resGet)
				},
				// отрицательный ответ
				resGet => {
					// вернем значение кнопок
					if (_oldStatus) this.restoreStatus(this.renameBackupId, _oldStatus)
					// ошибка сервера
					this.localErrorMessage = this.formatRequestError(resGet)
				}
			)
		},
		//---------------------------------------------------------------------
		// закрытие диалога создания бэкапа
		//---------------------------------------------------------------------
		hideCreateModal() {
			EventBus.$emit('w5-body-scroll-enable')
			this.showCreateModal = false
			this.hideModalMask()
		},
		//---------------------------------------------------------------------
		// закрытие диалога удаления
		//---------------------------------------------------------------------
		hideDeleteModal() {
			if (this.deleteModalTimerHandle)
			{
				clearInterval(this.deleteModalTimerHandle)
				this.deleteModalTimerHandle = false
			}
			EventBus.$emit('w5-body-scroll-enable')
			this.showDeleteModal = false
			this.hideModalMask()
		},
		//---------------------------------------------------------------------
		// открытие/закрытие меню строки
		//---------------------------------------------------------------------
		toggleMenu(row) {
			// если требуется закрыть все открытые меню
			if (row === 'off')
			{
				this.cacheData.forEach(item => {
					item['__btnShow'] = false
				})
				return
			}

			// меняем видимость на противоположную в заданой строке
			this.cacheData.forEach(item => {
				if (String(item.id) === String(row.id))
					item['__btnShow'] = !item['__btnShow']
				else
					item['__btnShow'] = false
			})

			// рассчитаем - куда открывать
			this.UpOrDown(row['id'])
		},
		//---------------------------------------------------------------------
		// куда открывать - вверх или вниз
		//---------------------------------------------------------------------
		UpOrDown(id) {
			// по умолчанию стиля нет
			this.cssUl = false

			// находим главный блок
			let _div = $('div[data-id="' + id + '"]')
			if (!_div.length) return

			// в нем находим блок с меню
			let _ul = _div.find('ul:first')
			if (!_ul.length) return

			// находим расположение главного блока и высоты
			let _rect = _div.offset()
			let _heightDiv = _div.height()
			let _heightUl = _ul.height()

			// расчитаем координаты низ блока с меню
			let _bottomUl = _rect.top + _heightDiv + _heightUl + 10 - $(window).scrollTop()
			// если они ниже высоты окна
			if (_bottomUl > window.innerHeight) this.cssUl = 'top: -' + (_heightDiv + _heightUl) + 'px'
		}

		//---------------------------------------------------------------------
	},
	//=========================================================================
	// наблюдатель
	//=========================================================================
	watch: {
		'vdsInfo': {
			handler: function() {
				this.refreshBackupSchedule()
			},
			deep: true
		},
		'active': function(value) {
			if (this.active)
			{
				Promise.all([
					this.refreshBackupSchedule(),
					this.requestBackupList(),
					this.getVdsBackupData()
				])
			}
		},
		'access': function(access) {
			this.Access = access
		},
		'parentError': function(value) {
			this.Error = value
		}/*,
		'backupList.list': function(newList) {
			if (this.active && newList && newList.length)
			{
				this.cacheData = []
				for (let i = 0; i < newList.length; i++)
				{
					// получим строку
					let _row = Object.assign({}, newList[i])
					// добавим свой статус
					_row['Status'] = this.Status(newList[i])
					// добавим признак - показ кнопки
					_row['__btnShow'] = false

					// добавим
					this.cacheData.push(_row)
				}

				// отсортируем по дате создания
				this.cacheData.sort(Helper.naturalCompareObjectField('created', 0))
			}
		}
		*/
	},

	//=========================================================================
	// используемые компоненты
	//=========================================================================
	components: {
		Field
	}

	//=========================================================================
}
///////////////////////////////////////////////////////////////////////////////
</script>

<style>
.w5-snapshot-table-th--1 {
	width: 30px;
	text-align: center;
}
.w5-snapshot-table-th-1 {
	width: 115px;
	text-align: center;
}
.w5-snapshot-table-th-2 {
	width: 120px;
}
.w5-snapshot-table-th-3 {
	width: 160px;
}
.w5-form-row.btn-wrapper {
	margin-top: 15px;
}
.top-btn {
	margin: 0
}
@media (max-width: 767px) {
	.top-btn {
		margin: 15px 0;
		width: 100%;
	}
}

.vds-pagination {
	display: flex;
	justify-content: flex-start;
	margin-top: 20px;
}
.vds-pagination span {
	display: block;
	height: 29px;
	width: 29px;
	font-size: 80%;
	line-height: 29px;
	text-align: center;
	color: #337ab7;
	border-left: 1px solid #eee;
	border-top: 1px solid #eee;
	border-bottom: 1px solid #eee;
	cursor: pointer;
}
.vds-pagination span:last-of-type {
	border-right: 1px solid #eee;
	border-radius: 0 3px 3px 0;
}
.vds-pagination span:first-of-type {
	border-radius: 3px 0 0 3px;
}
.vds-pagination span.info {
	background-color: #2c8ad8;
    border-color: #2c8ad8;
	color: white;
    user-select: none;
	cursor: default;
}
.vds-pagination span:not(.info):hover {
	color: #23527c;
    background-color: #eee;
}
.vds-pagination span.info + span {
	border-left-color: transparent;
	width: 28px;
}
</style>



// WEBPACK FOOTER //
// backup.vue?685ab30c